<template>
  <f7-page>
    <f7-navbar title="菜單草稿名稱 / ID 設定" back-link="back"></f7-navbar>

    <f7-list no-hairlines-md>
      <f7-list-item>
        <f7-label>菜單名稱</f7-label>
        <f7-input type="text" placeholder="ex. VIP" :value="title" @input="title = $event.target.value" clear-button></f7-input>
      </f7-list-item>
      <f7-list-item>
        <f7-label>菜單 ID</f7-label>
        <f7-input type="text" placeholder="顯示於網址上, 只限英文字母及數字" :value="variation" @input="variation = $event.target.value" clear-button></f7-input>
      </f7-list-item>
    </f7-list>

    <f7-segmented>
      <f7-button raised fill @click="save" style="background-color: #4CAF50; margin: 0px 5px;">儲存</f7-button>
      <f7-button raised fill back style="background-color: #FF0000; margin: 0px 5px;">取消</f7-button>
    </f7-segmented>

    <f7-block>
      說明：
      <ul>
        <li>ID 只限英文字母與數字</li>
        <li>菜單名稱可為中文</li>
        <li>ID 將會顯示於點餐的網址上</li>
        <li>發佈菜單時，將會覆蓋相同 ID 的菜單</li>
      </ul>
    </f7-block>
  </f7-page>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import Tabs from '@/common/components/Tabs'
import { storeClient } from '@/service/apiClients'

export default {
  data () {
    return {
      title: null,
      variation: this.menuDraftVariationProp,
      oldVariation: this.menuDraftVariationProp
    }
  },
  async created () {
    await this.setStore(this.storeIdProp)
    this.title = this.currentDraft.title
  },
  computed: {
    ...mapState('menuDraftModule', ['currentDraft']),
    ...mapGetters(['storeId'])
  },
  props: {
    storeIdProp: String,
    menuDraftVariationProp: String
  },
  methods: {
    ...mapActions(['setStore']),
    ...mapActions('menuDraftModule', ['setCurrentDraftInfo']),
    async save () {
      try {
        const { data: newDraftInfo } = await storeClient.put(`/stores/${this.storeId}/menus/drafts/${this.currentDraft.variation}/info`, {
          title: this.title,
          variation: this.variation
        })
        this.setCurrentDraftInfo({ variation: this.oldVariation, info: newDraftInfo })
        this.oldVariation = this.variation
      } catch (e) {
        console.error(e.message)
      }
    }
  },
  components: {
    Tabs
  }
}
</script>
